import React from "react";
import firebase from "firebase/app";
import 'firebase/storage';


export default  function Enviarecado(code, fila,recado,remetente) {

  var rec = recado+" - "+remetente;

  var unit1 = firebase.firestore().collection("usuarios").where('usertipo','in',['2','3','4','5','6','7']).
    where(code,'==',fila).get()
    .then(function(querySnapshot) {
      
      querySnapshot.forEach(function(doc) {
    
//******************* */
var unit = firebase.firestore().collection("usuarios").doc(doc.id).collection('recados').doc();



unit.set({recado:rec, statusrecado: "novo", datarecado:firebase.firestore.Timestamp.fromDate(new Date())})
.then(() => {
console.log("locsaliza successfully updated!");

})
.catch((error) => {
// The document probably doesn't exist.
console.error("Error updating document: ", error);
});

//******************* */

      });
    }).catch(function(error) {
      console.log("erro carregar as unidades de tipos veiculos: ", error);
      alert('Não foi Possível carregar Motoristas.');
  });

    
return

}
export {Enviarecado}